import {
  toWSDateString,
  WSFilterOption
} from "@wingspanhq/fe-component-library";
import { BulkStatus } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { useBulkPayablesBatchesQuery } from "../../../../BulkImporter/query/bulkPayable/queries";
import { BulkResource } from "../../../../BulkImporter/types";
import { getUploadedFilename } from "../../../../BulkImporter/utils/getUploadedFilename";

/**
 * Builds the select options for the "Bulk batch" payables filter from the
 * list of completed/failed bulk payable import batches.
 */
export function useBulkBatchFilterOptions(): WSFilterOption<"checkbox">[] {
  const query = useBulkPayablesBatchesQuery();

  return useMemo(
    () =>
      (query.data || [])
        .filter(bulkBatch =>
          [BulkStatus.Complete, BulkStatus.Failed].includes(bulkBatch.status)
        )
        .map(bulkBatch => ({
          name: bulkBatch.bulkPayableBatchId,
          label:
            getUploadedFilename(bulkBatch, BulkResource.Payable) +
            ` (created ${toWSDateString(bulkBatch.createdAt)})`
        })),
    [query.data]
  );
}
